import { Inject, Injectable } from "@angular/core";
import { LocalStorageService } from "angular-2-local-storage";
import { WindowRefService } from "./window.service";
import { ApiService } from "./api.service";
import { DomSanitizer, Title } from "@angular/platform-browser";
import { AnalyticsService } from "./analytics.service";

@Injectable()
export class AppService {
    private page = {
        title: '',
        name: ''
    };
    config;
    private _window: any;

    private appTitles = {
        CB: 'ClientBooks',
        SPROUT: 'Sprout'
    };

    private urls = {
        CB: 'cb_url',
        SPROUT: 'sprout_url'
    };

    constructor(
        windowRef: WindowRefService,
        private localStorageService: LocalStorageService,
        @Inject(ApiService) private ApiService: any,
        private titleService: Title,
        private ga: AnalyticsService
    ) {
        this._window = windowRef.nativeWindow;
    }
    getAppName() {
        return this.localStorageService.get('params')
            ? this.localStorageService.get<any>('params').client_id.split('_')[0].split('.')[0]
            : null;
    }
    getAppTitle() {
        var appTitles = {
            'taxapp': 'Tax App',
            'clientportal': this.appTitles[process.env.MODE] || '1-800Accountant',
            'vto': 'Virtual Tax Organizer',
            'vto2015': 'Virtual Tax Organizer',
            'website': this.appTitles[process.env.MODE] || '1-800Accountant'
        };
        var appName = this.getAppName();
        return appName ? appTitles[appName] : '';
    }
    login(data, formEl) {
        var form = formEl || document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action',
            this._window.ApiConfig.url + 'login?'
            + 'client_id=' + this.localStorageService.get<any>('params').client_id
            + '&client_secret=' + this.localStorageService.get<any>('params').client_secret
            + '&response_type=' + this.localStorageService.get<any>('params').response_type
            + '&redirect_uri=' + this._window.encodeURIComponent(this.localStorageService.get<any>('params').redirect_uri.replace(/\?.*#/, '#'))
            + '&state=' + this.localStorageService.get<any>('params').state || ''
        );

        var addParam = function (key, value) {
            var hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', value);
            form.appendChild(hiddenField);
        };

        addParam('username', data.username);
        addParam('password', data.password);
        addParam('captcha', data.captcha);
        document.body.appendChild(form);
        form.submit();
    }

    linkSSToBusiness(data) {
        var form = document.createElement('form');
        form.setAttribute('method', 'POST');
        form.setAttribute('action',
            this._window.ApiConfig.url + 'api/squarespace/business/connect'
        );

        var addParam = function (key, value) {
            var hiddenField = document.createElement('input');
            hiddenField.setAttribute('type', 'hidden');
            hiddenField.setAttribute('name', key);
            hiddenField.setAttribute('value', value);
            form.appendChild(hiddenField);
        };

        addParam('code', data.code);
        addParam('state', data.state);
        document.body.appendChild(form);
        form.submit();
    }

    connectSelectedBusinessToSS(data) {
        var form = document.createElement('form');
        form.setAttribute('method', 'GET');
        form.setAttribute('action',
            this._window.ApiConfig.url + `api/squarespace/business/select/${data.business_id}`
        );

        document.body.appendChild(form);
        form.submit();
    }

    setDefaultParams() {
        var defaultClientId = this._window.ApiConfig.client_id;
        var defaultClientSecret = this._window.ApiConfig.client_secret;
        var params = this.localStorageService.get<any>('params') || {};

        if (!params.client_id || !params.client_secret) {
            params.client_id = defaultClientId;
            params.client_secret = defaultClientSecret;
            params.redirect_uri = this.ApiService.config.cp[this.urls[process.env.MODE] || 'url'] + '/#/?oauth';
            params.response_type = 'token';
            params.state = '';

            this.localStorageService.set('params', params);
            this.titleService.setTitle(this.page.title + ' | ' + this.getAppTitle());
        }
    }
    refreshPageData(current) {
        if (current) {
            this.page = {
                title: current.title,
                name: current.page
            };
            this.titleService.setTitle(current.title + ' | ' + this.getAppTitle());
            this._window.document.body.classList.add('page-' + current.page);
            this.ga.trackPageview();
        }
    }
    trackEvent(a, b, c) {
        this.ga.trackEvent(a, b, c);
    }
}
